<p-tabView [activeIndex]="actualTabIndex()" (onChange)="onTabChange($event)" [scrollable]="true" class="shared-tabs">
  @for (tab of filteredTabs(); track $index) {
  <p-tabPanel [header]="tab.title | translate">
    <ng-container *ngTemplateOutlet="componentTemplate; context: { $implicit: tab, index: $index }">
    </ng-container>
  </p-tabPanel>
  }
</p-tabView>

<!-- Template for rendering dynamic components -->
<ng-template #componentTemplate let-tab let-index="index">
  <ng-container *ngComponentOutlet="tab.component; inputs: getResolvedInputs(index)">
  </ng-container>
</ng-template>